import ResourcesDispatcher from "../../config/ResourcesDispatcher";
class Cell {
    constructor(_x, _y, index, reelIndex) {
        this.on = true;
        this.memo = 0;
        this.reel = null;
        this.index = index;
        this.reelIndex = reelIndex;
        let cellGeom = layoutBuilder.getNodeByPath(`Basegame/grid/reels/reel_${reelIndex}/cell_${index}/cell#geom`);
        this.baseSymbolSpineRaw = ResourcesDispatcher.GAME_CONSTANTS.symbolSpines;
        this.baseSymbolImageRaw = ResourcesDispatcher.GAME_CONSTANTS.symbolImagesOn;
        this.baseSymbolImage = scene.add.image(cellGeom?.phaser.display?.x, cellGeom?.phaser.display?.y, this.getSymbolImageRaw(0).key, this.getSymbolImageRaw(0).frame)
            .setOrigin(cellGeom?.phaser.display?.originX, cellGeom?.phaser.display?.originY);
        this.baseSymbolSpines = [];
        for (let i = 0; i < this.baseSymbolSpineRaw.length; i++) {
            const spine = scene.add.spine(cellGeom?.phaser.display?.x, cellGeom?.phaser.display?.y, this.getSymbolSpineRaw(i).jsonKey, this.getSymbolSpineRaw(i).atlasKey).setOrigin(0.5).setVisible(false);
            this.baseSymbolSpines.push(spine);
        }
        let linkFont = globalVariableManager.getFont().overrideFont({ fontSize: 50, color: "#FF0000" });
        this.linkSpineValueText = scene.add.text(0, 0, "", linkFont).setOrigin(0.5);
        this.linkSpinContainer = scene.add.container(0, 0, [this.linkSpineValueText]).setVisible(false);
        this.container = layoutBuilder.findByPath(`Basegame/grid/reels/reel_${reelIndex}/cell_${index}`);
        this.container.add([this.baseSymbolImage, ...this.baseSymbolSpines, this.linkSpinContainer]);
    }
    setOn(on) {
        this.on = on;
    }
    setMemo(memo) {
        this.memo = memo;
    }
    setIndex(index) {
        this.index = index;
    }
    /** PUBLIC GETTERS **/
    getOn() {
        return this.on;
    }
    getMemo() {
        return this.memo;
    }
    getContainer() {
        return this.container;
    }
    getBaseContainer() {
        // return this.baseGameContainer;
        return null;
    }
    getLinkSpinContainer() {
        return this.linkSpinContainer;
    }
    getIndex() {
        return this.index;
    }
    getSymbolSpines() {
        return this.baseSymbolSpineRaw;
    }
    getSymbolSpineRaw(memo) {
        return this.baseSymbolSpineRaw[memo];
    }
    getSpine(memo) {
        return this.baseSymbolSpines[memo];
    }
    getImage() {
        return this.baseSymbolImage;
    }
    setReel(reel) {
        this.reel = reel;
    }
    refreshInternalPositions() {
        const cellGeom = layoutBuilder.getNodeByPath(`Basegame/grid/reels/reel_${this.reelIndex}/cell_${this.index}/cell#geom`);
        if (!cellGeom)
            return;
        const x = cellGeom.phaser?.display?.x ?? 0;
        const y = cellGeom.phaser?.display?.y ?? 0;
        this.baseSymbolImage.setPosition(x, y);
        this.baseSymbolImage.setOrigin(cellGeom.phaser?.display?.originX ?? 0.5, cellGeom.phaser?.display?.originY ?? 0.5);
        this.baseSymbolSpines.forEach(spine => spine.setPosition(x, y));
    }
    /*******************/
    /** PRIVATE GETTERS **/
    getExtraWildSpine() {
        return this.baseSymbolSpines[ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD];
    }
    getSymbolImageRaw(memo) {
        return this.baseSymbolImageRaw[memo];
    }
    /*******************/
    applySymbolTint(memo, isOn) {
        this.baseSymbolImage.setTexture(this.getSymbolImageRaw(memo).key, this.getSymbolImageRaw(memo).frame);
        this.baseSymbolImage.setTint(isOn ? 0xFFFFFF : 0x7F7F7F);
    }
    turnOn() {
        this.on = true;
        this.applySymbolTint(this.getMemo(), true);
        this.reel.expandingWild?.turnOnWildAnimation();
    }
    turnOff() {
        this.on = false;
        this.applySymbolTint(this.getMemo(), false);
        this.stopAnimation();
        this.reel.expandingWild?.turnOffWildAnimation();
    }
    resetLayer() {
        if (!this.reel) {
            return;
        }
        if (!this.reel.getContainer().exists(this.container)) {
            this.reel.getContainer().add(this.container);
        }
    }
    showFrame() { }
    hideFrame() { }
    checkLayer() { }
    setCellInfo(cellMemo, stopped = false, multiplier = 0) {
        // this.baseGameContainer.setVisible(true);
        this.baseSymbolImage.setVisible(true);
        this.baseSymbolSpines.forEach(s => s.setVisible(false));
        this.setMemo(cellMemo);
        this.cancelDelayedAnimationForMemo();
        //Chiamata di idle
        if (ResourcesDispatcher.GAME_CONSTANTS.ANIMATED_SYMBOLS.includes(cellMemo)) {
            this.scheduleDelayedAnimationForMemo(cellMemo);
        }
        this.on ? this.applySymbolTint(cellMemo, true) : this.applySymbolTint(cellMemo, false);
        this.linkSpinContainer.setVisible(false);
        // TODO: controllare questo codice e renderlo dinamico in base alla modalità
        // (in base potremmo non avere la modalità linkspin e quindi non ci serve mostrare i jackpot)
        // if (multiplier > 0 && 
        //     scene.gameArea.gameDataManager.getJackpots().map((jackpot: any) => { return jackpot * (window as any).getCurrentBet!().total}).indexOf(multiplier) === -1 && stopped) {
        //     this.linkSpineValueText.setText(Utils.formatCurrency(multiplier))
        //     this.linkSpinContainer.setVisible(true);
        // } else {
        //     this.linkSpineValueText.setText("");
        //     this.linkSpinContainer.setVisible(false);
        // }
    }
    expandWild(isWinning) {
        return new Promise((resolve) => {
            this.baseSymbolImage.setVisible(false);
            const extraWildSpine = this.getExtraWildSpine();
            extraWildSpine.setVisible(false);
            this.reel.getContainer().bringToTop(this.container);
            this.container.setVisible(true);
            const animationSuffix = String(3 - (this.index - 1));
            const animationState = extraWildSpine.animationState;
            const listener = {
                complete: async () => {
                    resolve(true);
                },
                start: () => {
                    scene.tweens.add({
                        targets: extraWildSpine,
                        alpha: 1,
                        duration: 50,
                        ease: 'Linear',
                        onComplete: () => {
                            extraWildSpine.setVisible(true);
                        }
                    });
                    if (isWinning) {
                        soundManager.play(ResourcesDispatcher.SOUNDS.ESPANSIONE_JOLLY);
                        animationManager.topSideGridAnimation?.jumpscare();
                    }
                }
            };
            animationState.setAnimation(0, "On_" + animationSuffix, false);
            if (isWinning) {
                const trackEntry = animationState.addAnimation(0, "opening_" + animationSuffix, false, 0);
                trackEntry.listener = listener;
            }
            else {
                const trackEntry = animationState.addAnimation(0, "nowin_" + animationSuffix, false, 0);
                trackEntry.listener = listener;
            }
        });
    }
    contractWild() {
        return new Promise((resolve) => {
            const extraWildSpine = this.getExtraWildSpine();
            if (extraWildSpine) {
                const trackEntry = extraWildSpine.animationState.addAnimation(Cell.WinAnimationTrack, "closing_" + (3 - (this.index - 1)), false, 0);
                trackEntry.alpha = Cell.WinAnimationAlpha;
                const completeListener = {
                    complete: () => {
                        // Remove this specific listener after it is called
                        resolve(true);
                        extraWildSpine.animationState.removeListener(completeListener);
                    }
                };
                trackEntry.listener = completeListener;
            }
            else {
                resolve(true);
            }
        });
    }
    extraWildAnimation(isWinning) {
        return new Promise((resolve) => {
            this.baseSymbolImage.setVisible(false);
            const extraWildSpine = this.getExtraWildSpine();
            extraWildSpine.setVisible(true);
            this.reel.getContainer().bringToTop(this.container);
            const animationState = extraWildSpine.animationState;
            if (isWinning) {
                animationState.addAnimation(0, "animation", false, 0);
            }
            // else {
            //     this.turnOffWildAnimation();
            // }
            resolve(true);
        });
    }
    turnOffWildAnimation() {
        this.getExtraWildSpine().skeleton.color.set(0.5, 0.5, 0.5, 1);
    }
    turnOnWildAnimation() {
        this.getExtraWildSpine().skeleton.color.set(1, 1, 1, 1);
    }
    isValidGameMode() {
        const gameMode = gameLogicVariableManager.getCurrentGameMode();
        return gameMode === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME || gameMode === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.LINKSPIN;
    }
    setPlayAnimationListener(trackEntry, loop, resolve) {
        const resolveOnce = () => {
            if (!this.pendingPlayAnimationResolve)
                return;
            const pendingResolve = this.pendingPlayAnimationResolve;
            this.pendingPlayAnimationResolve = undefined;
            pendingResolve(true);
        };
        if (!loop) {
            this.pendingPlayAnimationResolve = resolve;
            trackEntry.listener = {
                complete: () => {
                    if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
                        this.getSpine(this.getMemo()).setVisible(false);
                        this.getSpine(this.getMemo()).skeleton.setToSetupPose();
                        this.baseSymbolImage.setVisible(true);
                    }
                    resolveOnce();
                },
                interrupt: () => {
                    this.baseSymbolImage.setVisible(true);
                    resolveOnce();
                },
                dispose: () => {
                    resolveOnce();
                }
            };
        }
        else {
            resolve(true);
        }
    }
    playAnimation(loop = false) {
        return new Promise((resolve) => {
            this.resolvePendingPlayAnimation();
            if (!this.isValidGameMode()) {
                console.error("Mode not implemented");
                resolve(true);
                return;
            }
            const symbolSpineRaw = this.getSymbolSpineRaw(this.getMemo());
            const animations = symbolSpineRaw?.animations;
            if (!animations || !animations.length) {
                resolve(true);
                return;
            }
            const trackEntry = this.getSpine(this.getMemo()).animationState.addAnimation(Cell.WinAnimationTrack, animations[0], loop);
            trackEntry.alpha = Cell.WinAnimationAlpha;
            this.getSpine(this.getMemo()).setVisible(true);
            this.baseSymbolImage.setVisible(false);
            this.setPlayAnimationListener(trackEntry, loop, resolve);
        });
    }
    playLandingAnimation() {
        return new Promise((resolve) => {
            // a simple animation that zoom in and out the image
            this.baseSymbolImage.setVisible(true);
            // perform a zoom in and out animation
            scene.tweens.add({
                targets: this.baseSymbolImage,
                scaleX: 1.2,
                scaleY: 1.2,
                duration: 300,
                ease: 'Linear',
                yoyo: true,
                repeat: 0,
                onComplete: () => {
                    resolve(true);
                }
            });
        });
    }
    stopAnimation() {
        this.resolvePendingPlayAnimation();
        if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
            this.cancelDelayedAnimationForMemo();
            this.getSpine(this.getMemo()).animationState.clearTrack(0);
            this.getSpine(this.getMemo()).setVisible(false);
            this.baseSymbolImage.setVisible(true);
        }
        else {
            this.cancelDelayedAnimationForMemo();
            this.getExtraWildSpine().animationState.clearTracks();
            this.getExtraWildSpine().setVisible(false);
            this.baseSymbolImage.setVisible(true);
        }
    }
    hideWild() {
        this.getExtraWildSpine().setVisible(false);
        this.baseSymbolImage.setVisible(false);
    }
    playIdleAnimation(memo, onComplete) {
        const animations = this.getSymbolSpineRaw(memo).animations;
        if (!animations) {
            onComplete();
            return;
        }
        const trackEntry = this.getSpine(memo).animationState.addAnimation(Cell.WinAnimationTrack, animations[2], false);
        trackEntry.alpha = Cell.WinAnimationAlpha;
        this.getSpine(memo).setVisible(true);
        this.baseSymbolImage.setVisible(false);
        trackEntry.listener = {
            complete: () => {
                if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
                    this.getSpine(memo).setVisible(false);
                    this.getSpine(memo).skeleton.setToSetupPose();
                    this.baseSymbolImage.setVisible(true);
                }
                onComplete();
            }
        };
    }
    scheduleIdleAnimationLoop(memo) {
        if (this.getMemo() !== memo)
            return;
        const delayMs = Math.floor(Math.random() * (20000 - 5000 + 1)) + 5000;
        this.delayedAnimForMemo = scene.time.delayedCall(delayMs, () => {
            this.playIdleAnimation(memo, () => {
                if (window.Game?.paused === false) {
                    this.scheduleIdleAnimationLoop(memo);
                }
            });
        });
    }
    scheduleDelayedAnimationForMemo(memo) {
        this.cancelDelayedAnimationForMemo();
        this.scheduleIdleAnimationLoop(memo);
    }
    resolvePendingPlayAnimation() {
        if (!this.pendingPlayAnimationResolve) {
            return;
        }
        const pendingResolve = this.pendingPlayAnimationResolve;
        this.pendingPlayAnimationResolve = undefined;
        pendingResolve(true);
    }
    cancelDelayedAnimationForMemo() {
        if (this.delayedAnimForMemo && !this.delayedAnimForMemo.hasDispatched) {
            this.delayedAnimForMemo.remove(false);
        }
        this.delayedAnimForMemo = undefined;
    }
}
Cell.OnOffAnimationTrack = 0;
Cell.WinAnimationTrack = 0;
Cell.OnOffAnimationAlpha = 1;
Cell.WinAnimationAlpha = 1;
export default Cell;
